import { combineReducers } from "redux";
import getCommentReducer from "./getCommentReducer";
import updateCommentReducer from "./updateCommentReducer";

const commentReducer = combineReducers({
    comment: getCommentReducer,
    updateComment: updateCommentReducer
});

export default commentReducer;